import React from 'react'
import PropTypes from 'prop-types'

const regex = /%%[a-zA-Z0-9_ ]+%%/g
/**
 * Props:
 * - target: (string)
 * - replace: (function (key) / object / array / node)
 *  - function (key): return React Node
 *  - object: map to object property by key
 *  - array: map to array element by parseInt(key) as index (** key need to be number)
 */
class ReplaceText extends React.Component {
    render () {
        let { target, replace } = this.props
        // console.log("replace type:", typeof replace, replace);
        //target: "了解更多%%refund_policy%%以及%%shipping_information%%"
        //matches: [ "%%refund_policy%%", "%%shipping_information%%" ]
        let matches = target.match(regex)
        //splits: [ "了解更多", "以及", "" ]
        let splits = target.split(regex)
        //result array of nodes
        let result = []
        splits.forEach((split, index) => {
            //push split
            if (split) {
                // console.log("Push span:", split);
                
                result.push(
                    <span key={`span-${index}`}>{split}</span>
                )
            }
            //if not last split
            if (index < splits.length - 1) {
                //find following match node
                let match = matches[index].replace(/^%%|%%$/g, "")
                let matchNode = null
                if (typeof replace === "function") {
                    //function
                    // console.log(`Push node returned by function, key:`, match);
                    matchNode = replace(match)
                }
                else if (Array.isArray(replace)) {
                    //array
                    if (typeof match === "string" && !isNaN(match)) {
                        let matchIndex = parseInt(match)
                        // console.log(`Push node from array, index:`, matchIndex);
                        matchNode = replace[matchIndex]
                    }
                }
                else if (typeof replace === "object") {
                    //object
                    // console.log(`Push node from object, key:`, match);
                    matchNode = replace[match]
                }
                //if match node exist, push to result
                if (matchNode) {
                    result.push(React.cloneElement(matchNode, {
                        key: `match-${index}`
                    }))
                }
            }
        })

        
        return result
    }
}

ReplaceText.propTypes = {
    target: PropTypes.string.isRequired,
    replace: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.objectOf(PropTypes.node),
        PropTypes.arrayOf(PropTypes.node),
    ])
}

export default ReplaceText